module.exports = __webpack_public_path__ + "static/hero-background-d918b3f98de08f7c460dc156798a4cf9.jpg";